<div class="wrapper">
  <span class="error">404</span>
  <div class="middle-text">
    <h2 class="mb-0">Seite nicht gefunden</h2>
  </div>
  <button class="btn" (click)="GoToHome()">Zurück zur Startseite</button>
</div>